import {Button, Form, FormGroup, Input, InputGroup, InputGroupText} from "reactstrap";
import withNavigateHook from "../../hooks/withNavigationHook";
import {useState} from "react";

const AutoCompleteInput = ({ navTo = "/songs/search", navigation }) => {
    const [query, setQuery] = useState("");

    const submit = (e) => {
        e.preventDefault();
        if (!query.trim()) return;

        if (typeof window.gtag === 'function') {
            window.gtag("event", "search", {
                search_term: query
            });
        }

        navigation(`${navTo}?q=${encodeURIComponent(query)}`);
    };

    return (
        <Form onSubmit={submit} autoComplete="off">
            <div className="twb-cta-group">
                <FormGroup className="mb-0">
                    <InputGroup className="input-group-alternative">
                        <InputGroupText>
                            <i className="ni ni-hat-3" />
                        </InputGroupText>
                        <Input
                            className="twb-input"
                            placeholder="Enter song title"
                            type="text"
                            maxLength="100"
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                        />
                    </InputGroup>
                </FormGroup>

                <Button color="primary" type="submit" className="twb-cta mt-3 mb-0">
                    SEARCH
                </Button>
            </div>
        </Form>
    );
};

export default withNavigateHook(AutoCompleteInput);
